import actionTypes from './actionTypes';

const initialState = {
  open_stats: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.GET_OPEN_STATS}_SUCCESS`: {
      return {
        ...state,
        open_stats: action.payload.open_stats,
      };
    }
    default: {
      return state;
    }
  }
};
